import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  constructor(private _requestService: RequestService) {}

  dadosFornecedor(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };

    return this._requestService.requestMethod(
      `company/api/Company/Get`,
      'GET',
      true,
      null,
      header
    );
  }

  dadosUsuario(companyID, restrictionKey, userID) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `user/api/User/Get/${userID}`,
      'GET',
      true,
      null,
      header
    );
  }

  listProfileData(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',   
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };    
    return this._requestService.requestMethod(
      `user/api/User/ProfileData`,
      'GET',
      true,
      null,
      header
    );
  }

  authorization(data) {
    let header = {
      'Content-Type': 'application/json',
    };
    return this._requestService.requestMethod(
      `authorization/api/Authorization/Login`,
      'POST',
      true,
      data,
      header
    );
  }

  updateProfileData(data: any) {
    return this._requestService.requestMethod(  
      `user/api/User/UpdateProfileData`,
      'PUT',
      true,
      data,
    );
  }

   updatePassword(data: any) {
    return this._requestService.requestMethod(  
      `user/api/User/UpdatePassword`,
      'PUT',
      true,
      data,
    );
  }

  forgotPassword(data: any) {
    return this._requestService.requestMethod(  
      `authorization/api/Authorization/ForgotPassword`,
      'POST',
      true,
      data,
    );
  }

  resetPassword(data: any) {
    return this._requestService.requestMethod(  
      `authorization/api/Authorization/ResetPassword`,
      'POST',
      true,
      data,
    );
  }

  includeUserSession(data: any) {
    let header = {
      'Content-Type': 'application/json',
    };
    return this._requestService.requestMethod(
      `user/api/User/includeUserSession`,
      'POST',
      true,
      data,
      header
    );
  }
}
